module.exports = __webpack_public_path__ + "media/images/menu/social-network-3643ea70ad6d41008b08c6eaefcd8cf3.svg";